exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FinishedButtons-module__wrapper___1WHVA{display:grid;gap:1em;width:-moz-fit-content;width:fit-content;margin:20px 0 0 auto}@media screen and (min-width:768px){.FinishedButtons-module__wrapper___1WHVA{bottom:-100px;grid-auto-flow:column}}.FinishedButtons-module__wrapper___1WHVA button{display:grid;grid-auto-flow:column;width:-moz-fit-content;width:fit-content;align-items:center;gap:10px;border-radius:100px;padding:.5em 1.2em;background-color:#1368e5;color:#fff;font-size:16px;font-weight:400}.FinishedButtons-module__wrapper___1WHVA button .FinishedButtons-module__sign-out___1SgTi{transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"wrapper": "FinishedButtons-module__wrapper___1WHVA",
	"sign-out": "FinishedButtons-module__sign-out___1SgTi"
};